export enum AccountingAccountType {
  Bank = 'bank',
  CreditCard = 'creditCard',
  AccountsReceivable = 'accountsReceivable',
  OtherCurrentAssets = 'otherCurrentAssets',
  FixedAssets = 'fixedAssets',
  OtherAssets = 'otherAssets',
  AccountsPayable = 'accountsPayable',
  OtherCurrentLiabilities = 'otherCurrentLiabilities',
  LongTermLiabilities = 'longTermLiabilities',
  Equity = 'equity',
  Income = 'income',
  OtherIncome = 'otherIncome',
  CostOfGoodsSold = 'costOfGoodsSold',
  Expenses = 'expenses',
  OtherExpenses = 'otherExpenses',
}

export const AccountingAccountTypeOptions = {
  [AccountingAccountType.Bank]: 'Bank',
  [AccountingAccountType.CreditCard]: 'Credit Card',
  [AccountingAccountType.AccountsReceivable]: 'Accounts Receivable (A/R)',
  [AccountingAccountType.OtherCurrentAssets]: 'Other Current Assets',
  [AccountingAccountType.FixedAssets]: 'Fixed Assets',
  [AccountingAccountType.OtherAssets]: 'Other Assets',
  [AccountingAccountType.AccountsPayable]: 'Accounts Payable (A/P)',
  [AccountingAccountType.OtherCurrentLiabilities]: 'Other Current Liabilities',
  [AccountingAccountType.LongTermLiabilities]: 'Long Term Liabilities',
  [AccountingAccountType.Equity]: 'Equity',
  [AccountingAccountType.Income]: 'Income',
  [AccountingAccountType.OtherIncome]: 'Other Income',
  [AccountingAccountType.CostOfGoodsSold]: 'Cost of Goods Sold',
  [AccountingAccountType.Expenses]: 'Expenses',
  [AccountingAccountType.OtherExpenses]: 'Other Expenses',
}

export const AccountingNormalBalanceOptions = {
  debit: 'Debit',
  credit: 'Credit',
}

export const AccountingStatementOptions = {
  balanceSheet: 'Balance Sheet',
  incomeStmt: 'Income Stmt',
}

export interface IAccountingAccount {
  id: number
  no: number
  type: string
  name: string
  number: string
  description?: string
  parentId?: number
  section?: string
  normalBalance?: string
  statement?: string
  notes?: string

  invalid?: boolean
}

export const getAccountTypeLabel = (type: string) =>
  AccountingAccountTypeOptions[type as AccountingAccountType] || type

/** Prefer explicit section; else account type; else statement classification. */
export const resolveAccountGroup = (section?: string | null, type?: string | null, statement?: string | null) => {
  const trimmedSection = section?.trim()
  if (trimmedSection) return trimmedSection

  const trimmedType = type?.trim()
  if (trimmedType) return getAccountTypeLabel(trimmedType)

  if (statement === 'balanceSheet') return AccountingStatementOptions.balanceSheet
  if (statement === 'incomeStmt') return AccountingStatementOptions.incomeStmt

  return 'Uncategorized'
}
